const luminance = color => {
    const hex = color.replace('#','');
    const full = hex.length === 3 ? hex.split('').map(char=>char+char).join('') : hex;
    if (!/^[a-f0-9]{6}$/i.test(full)) return null;
    const rgb = [0,2,4].map(index=>parseInt(full.slice(index,index+2),16)/255).map(value=>value<=0.04045?value/12.92:((value+0.055)/1.055)**2.4);
    return rgb[0]*0.2126+rgb[1]*0.7152+rgb[2]*0.0722;
};
export const contrastRatio = (foreground,background) => {
    const a=luminance(foreground),b=luminance(background);
    return a===null || b===null ? null : (Math.max(a,b)+0.05)/(Math.min(a,b)+0.05);
};
export function qrWarnings({foreground,background,logoSize,hasLogo,modules,width}) {
    const warnings=[];const ratio=contrastRatio(foreground,background);
    if(ratio!==null && ratio<4.5)warnings.push('Increase contrast between the code and its background.');
    if(hasLogo && logoSize>0.25)warnings.push('The logo covers a large area. Reduce it and test with several phones.');
    if(modules && width/(modules+8)<4)warnings.push('Use a larger export size so each QR module has at least four pixels.');
    return warnings;
}
